<template lang="pug" src="./Ads.pug"></template>

<script>
import { mapActions } from 'vuex'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'

import pt_BR from "vee-validate/dist/locale/pt_BR.json";
import en from "vee-validate/dist/locale/en.json";
import es from "vee-validate/dist/locale/es.json";

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: ['item'],
  data() {
    return {
      campaignName: '',
      weekDay: ['0', '1', '2', '3', '4', '5', '6'],
      allDay: true,
      timeFrom: '',
      timeTo: '',
      targetSelected: {},
      campaignTargeting: '',
      items: ['Instagram', 'Facebook', `${this.$t('ads.OTHERS')}`],
      rules: [value => !value || value.size < 2000000 || `${this.$t('ads.FILESIZEERROR')}`],
      timeDisabled: false,
      timeOn: null,
      timeOff: null,
      modalOn: false,
      modalOff: false,
      dateOn: new Date().toISOString().substr(0, 10),
      modalDateOn: false,
      dateOff: '',
      modalDateOff: false,
      previewUrl: '',
      file: '',
      showRegisterBt: true,
      showEditBt: false,
      btCreateDisabled: true,
      imgBlob: '',
      weekDayError: '',
      campaignTargetingError: '',
      appUrl: '',
      isNewCampain: true,
      activeMe: true
    }
  },
  methods: {
    ...mapActions(['saveAds', 'getFbId', 'editAds', 'disableAds', 'getUploadUrl', 'saveAds', 'uploadFile']),
    pickFile () {
      this.$refs.image.click ()
    },

    removeUTC (totalSecconds) {
      const time = Math.trunc(totalSecconds / 3600)
      const minutes = Math.trunc(totalSecconds % 3600 / 60)

      let now = new Date()
      now.setUTCHours(time)
      now.setMinutes(minutes)

      if(minutes < 10) {
        return (now.getHours()+':0'+minutes)
      }else{ return (now.getHours()+':'+minutes) }
    },

    ajustTime (totalMinutes) {
      console.log(totalMinutes)
      const time = Math.trunc(totalMinutes / 60)
      const minutes = Math.trunc(totalMinutes % 60)

      if(minutes < 10) {
        return (time+':0'+minutes)
      }else{ return (time+':'+minutes) }
    },

    transformTime(totalSecconds){
      const time = Math.trunc(totalSecconds / 3600)
      const minutes = Math.trunc(totalSecconds % 3600 / 60)

      if(minutes < 10) {
        return (time+':0'+minutes)
      }else{ return (time+':'+minutes) }
    },

    isActive(e){
      this.disable(e)
    },

    allDayAd () {
      if(this.allDay){
        this.timeOn = "0:00";
        this.timeOff = "23:59";
        this.timeDisabled = true;
      }else{
        this.timeDisabled = false;
      }
    },
    async onFileChange(e) {

      this.isNewCampain = true // trocou a imagem, nova campanha

      if(e != null){
        this.compress(e)
        this.btCreateDisabled = false
      }
    },
    compress(e) { // reduzir arquivo e salvar em jpeg
      const width = 700;
      const fileName = e.name
      const reader = new FileReader()
      reader.readAsDataURL(e)
      reader.onload = event => {
          const img = new Image()
          img.src = event.target.result
          img.onload = () => {
                  const elem = document.createElement('canvas')
                  elem.width = width
                  elem.height = width * img.height / img.width

                  const ctx = elem.getContext('2d')
                  ctx.drawImage(img, 0, 0, width, width * img.height / img.width)
                  ctx.canvas.toBlob((blob) => {
                      new File([blob], fileName, {
                          type: 'image/jpeg',
                          lastModified: Date.now()
                      });
                  }, 'image/jpeg', 1)

                  this.previewUrl = ctx.canvas.toDataURL('image/jpeg') // background do Preview
                  const newBlob = this.dataURItoBlob(ctx.canvas.toDataURL('image/jpeg'))
                  const resizedFile = new File([newBlob], "abc.jpg")
                  this.imgBlob = resizedFile // arquivo que será enviado para o S3
              },

              reader.onerror = error => console.log(error)
      }
    },

    dataURItoBlob(dataURI) {
        var byteString = atob(dataURI.split(',')[1]);
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        var blob = new Blob([ab], {type: mimeString});
        return blob;
    },

    async disable (shouldActive){
      this.validateCampaignTargeting()

      const timeOnStr = this.timeOn.split(":")
      const timeOn = (parseInt(timeOnStr[0]) * 3600) + (parseInt(timeOnStr[1]) * 60)

      const timeOffStr = this.timeOff.split(":")
      const timeOff = (parseInt(timeOffStr[0]) * 3600) + (parseInt(timeOffStr[1]) * 60)

      this.disableAds({
          _id: this.item._id,
          campanha: this.campaignName,
          urlDestino: this.campaignTargeting,
          urlApp: this.appUrl,
          diasSemana: this.weekDay,
          intervalo: {inicio: Date.parse(this.dateOn), fim: Date.parse(this.dateOff)},
          horas: {inicio: timeOn, fim: timeOff},
          identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
          nomeArquivo: this.item.nomeArquivo,
          ativo: shouldActive
      })
    },

    async editAd () {

      this.validateCampaignTargeting()

      const timeOnStr = this.timeOn.split(":")
      const timeOn = (parseInt(timeOnStr[0]) * 60) + (parseInt(timeOnStr[1]))

      const timeOffStr = this.timeOff.split(":")
      const timeOff = (parseInt(timeOffStr[0]) * 60) + (parseInt(timeOffStr[1]))

      if(this.isNewCampain){ // trocou a imagem, nova campanha
        this.disable(false)
        this.registerAd()
      }else{ // apenas edita
        await this.editAds({
            _id: this.item._id,
            campanha: this.campaignName,
            urlDestino: this.campaignTargeting,
            urlApp: this.appUrl,
            diasSemana: this.weekDay,
            intervalo: {inicio: Date.parse(this.dateOn), fim: Date.parse(this.dateOff)},
            horas: {inicio: timeOn, fim: timeOff},
            ativo: this.activeMe,
            identity: window.localStorage.getItem('selectedHotspot').split('"').join(''),
            nomeArquivo: this.item.nomeArquivo
        })
      }
    },

    async registerAd () {

      var valid = await this.$refs.form.validate();
      if(this.weekDay.length == 0){
        valid = false
        this.weekDayError = `${this.$t('errors.WEEKDAYERROR')}`
      }
      if (valid && this.campaignTargetingError === '') {

        const timeOnStr = this.timeOn.split(":")
        const timeOn = (parseInt(timeOnStr[0]) * 60) + (parseInt(timeOnStr[1]))

        const timeOffStr = this.timeOff.split(":")
        const timeOff = (parseInt(timeOffStr[0]) * 60) + (parseInt(timeOffStr[1]))

        const fileName = `${Date.now()}.png`
        const bucketHs = 'c_'+window.localStorage.getItem('selectedHotspot').split('"').join('').substring(0, window.localStorage.getItem('selectedHotspot').split('"').join('').indexOf('_'))
        const key = bucketHs+'/publicidades/'+fileName
        const contentType = "image/png"
        const file = new File([this.imgBlob], fileName, { type: 'image/png' })

        let url
        try {
          url = await this.getUploadUrl({
            op: 'PUT',
            bucket: process.env.VUE_APP_S3_BUCKET,
            key,
            contentType
          })
        } catch (err) {
          console.error('Erro ao obter URL de upload:', err)
          return
        }
   
        try {
          const success = await this.uploadFile({
            op: 'PUT',
            url: url,
            contentType: contentType,
            formData: file
          })

          if(success) { 
            this.saveAds({
              campanha: this.campaignName,
              nomeArquivo: fileName,
              urlDestino: this.campaignTargeting,
              urlApp: this.appUrl,
              diasSemana: this.weekDay,
              intervalo: {inicio: Date.parse(this.dateOn), fim: Date.parse(this.dateOff)},
              horas: {inicio: timeOn, fim: timeOff},
              ativo: 1,
              identity: window.localStorage.getItem('selectedHotspot').split('"').join('')
            }) 
          }

        } catch (error) {
          console.error('Error uploading file:', error)
          return
        }
      }
    },

    // async registerAd () {

    //   var valid = await this.$refs.form.validate();
    //   if(this.weekDay.length == 0){
    //     valid = false
    //     this.weekDayError = `${this.$t('errors.WEEKDAYERROR')}`
    //   }
    //   if (valid) {
    //     const fileName = new Date().getTime()

    //     const timeOnStr = this.timeOn.split(":")
    //     const timeOn = (parseInt(timeOnStr[0]) * 60) + (parseInt(timeOnStr[1]))

    //     const timeOffStr = this.timeOff.split(":")
    //     const timeOff = (parseInt(timeOffStr[0]) * 60) + (parseInt(timeOffStr[1]))

    //     const bucketHs = 'c_'+window.localStorage.getItem('selectedHotspot').split('"').join('').substr(0, window.localStorage.getItem('selectedHotspot').split('"').join('').indexOf('_'))

    //     await this.uploadToS3AndSave({
    //         Bucket: process.env.VUE_APP_S3_BUCKET+'/'+bucketHs+'/publicidades',
    //         Key: fileName+'.jpg',
    //         ACL: 'public-read',
    //         Body: this.imgBlob,
    //         campanha: this.campaignName,
    //         nomeArquivo: fileName+'.jpg',
    //         urlDestino: this.campaignTargeting,
    //         urlApp: this.appUrl,
    //         diasSemana: this.weekDay,
    //         intervalo: {inicio: Date.parse(this.dateOn), fim: Date.parse(this.dateOff)},
    //         horas: {inicio: timeOn, fim: timeOff},
    //         ativo: 1,
    //         identity: window.localStorage.getItem('selectedHotspot').split('"').join('')
    //     })
    //   }
    // },
    async validateCampaignTargeting(){
      switch (this.targetSelected){
        case 'Instagram':

          if(/(?:(?:http|https):\/\/)?(?:www.)?(?:instagram.com|instagr.am)\/([A-Za-z0-9-_]+)/im.test(this.campaignTargeting)){ // verifica se é uma url válida do instagram
            this.campaignTargetingError = ''
            var instaUser = this.campaignTargeting.substring(
              this.campaignTargeting.lastIndexOf(".com/") + 5
            )
            if (instaUser.substr(instaUser.length - 1) == '/'){ instaUser = instaUser.slice(0, -1) }
            this.appUrl = 'instagram://user?username='+instaUser
          }else{
            this.campaignTargetingError = 'URL inválida para instagram'
          }
          break

        case 'Facebook':
          if(/^(https?:\/\/)?(www\.)?facebook.com\/[a-zA-Z0-9()?]/.test(this.campaignTargeting)){
            this.campaignTargetingError = ''
            const fbId = await this.getFbId({
               url: encodeURIComponent(this.campaignTargeting)
            })
            if(fbId != undefined){
              this.appUrl = 'fb://profile/'+fbId
            }else{
              this.campaignTargetingError = 'Essa URL não redirecionará para o app do facebook'
            }
          }else{
            this.campaignTargetingError = 'Essa URL não redirecionará para o app do facebook'
          }
          break

        default: {
          const urlRegex = /^(https?:\/\/)?([a-z\d-]+\.)+[a-z]{2,6}(:\d+)?(\/[\w.-]*)*\/?$/i
          if (urlRegex.test(this.campaignTargeting)) {
            this.campaignTargetingError = ''
            this.appUrl = this.campaignTargeting
          } else {
            this.campaignTargetingError = 'Informe uma URL válida'
          }
          break
          }
      }
      
    },
  tChanged(){
    this.$nextTick(() => {
      if (this.$refs.campaignTargetingField) {
        this.$refs.campaignTargetingField.focus()
      }
    })
    if(this.campaignTargeting != ''){ this.validateCampaignTargeting() }
  },
  },
  mounted(){
  },
  computed: {

    lang(){
      return this.$store.getters.locale
    },
  },
  watch: {
    lang (newLang) { // se trocou a linguagem, revalida o form
      const lg = { en: en, pt: pt_BR, es: es };
      localize(`${newLang}`, lg[newLang]);

      this.$refs.form.validate();
    }
  },
  beforeMount(){

    if(this.item != null){

      this.activeMe = this.item.ativo
      this.isNewCampain = false

      this.showRegisterBt = false
      this.showEditBt = true

      this.campaignName = this.item.campanha
      this.campaignTargeting = this.item.urlDestino

      this.allDay = false
      this.dateOn = this.item.intervalo.inicio.slice(0,10)
      this.dateOff = this.item.intervalo.fim.slice(0,10)

      this.timeOn = this.ajustTime(this.item.horas.inicio)
      this.timeOff = this.ajustTime(this.item.horas.fim)

      const folder = 'c_'+this.item.identity.substr(0, this.item.identity.indexOf('_'))
      this.previewUrl = 'https://cdn.semsenha.com/'+folder+'/publicidades/'+this.item.nomeArquivo


      if(this.item.urlDestino.search("facebook") != -1){ this.targetSelected = 'Facebook' }
      else if(this.item.urlDestino.search("instagram") != -1){ this.targetSelected = 'Instagram' }
      else{this.targetSelected = `${this.$t('ads.OTHERS')}`}

      //let days = []

      this.weekDay = []
      this.item.diasSemana.map((value) => {
        const val = value.toString()
        this.weekDay.push(val)
      })

    }else{
      this.allDayAd()
      var futureDateOff = new Date()
      futureDateOff.setYear(futureDateOff.getFullYear()+3)
      this.dateOff = futureDateOff.toISOString().substr(0, 10)
    }
  }
}
</script>

<style>
.blurredBg{
  width: 100%;
  height: 100%;
  filter: blur(30px);
  background: url("{{ previewUrl }}") no-repeat center;
  background-size: cover;
}
.frame { /* centralizar img verticalmente */
    position: relative;
}
img {
    max-height: 100%;
    max-width: 100%;
    width: auto;
    height: auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
}

</style>
